import React from "react";
import CountUp from "react-countup";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faProductHunt } from "@fortawesome/free-brands-svg-icons";
import { faList, faUsers } from "@fortawesome/free-solid-svg-icons";

library.add(faProductHunt, faUsers, faList);

const Company = () => {
  return (
    <section>
        <div className=" [ about-counter-section ] ">
          <div className=" [ counter ] ">
            <div className=" [ counter__ic ] ">
              <span className=" [ counter__ic__icon ] ">
                <FontAwesomeIcon icon={faProductHunt} />
              </span>

              <span className=" [ counter__ic__value ] ">
                <CountUp start={0} end={35} duration={2} suffix="" />
              </span>
            </div>
            <h3 className=" [ counter__txt ] ">Completed Projects</h3>
          </div>

          <div className=" [ counter ] ">
            <div className=" [ counter__ic ] ">
              <span className=" [ counter__ic__icon ] ">
                <FontAwesomeIcon icon={faUsers} />
              </span>

              <span className=" [ counter__ic__value ] ">
                <CountUp start={0} end={120} duration={2} suffix="" />
              </span>
            </div>
            <h3 className=" [ counter__txt ] ">Students Around World</h3>
          </div>

          <div className=" [ counter ] ">
            <div className=" [ counter__ic ] ">
              <span className=" [ counter__ic__icon ] ">
                <FontAwesomeIcon icon={faList} />
              </span>

              <span className=" [ counter__ic__value ] ">
                <CountUp start={0} end={5} duration={2} suffix="" />
              </span>
            </div>
            <h3 className=" [ counter__txt ] "> Courses Offered</h3>
          </div>
        </div>
    </section>
  );
};

export default Company;
